export const validateMobile = (mobile) => {
  return mobile.match(/^[9|8][0-9]{7}$/gm) ? true : false;
};
